export const Period = {
  AM: 'AM',
  PM: 'PM',
} as const

export type Period = (typeof Period)[keyof typeof Period]
